import { render, staticRenderFns } from "./pushModal.vue?vue&type=template&id=050cfd70&scoped=true"
import script from "./pushModal.vue?vue&type=script&lang=js"
export * from "./pushModal.vue?vue&type=script&lang=js"
import style0 from "./pushModal.vue?vue&type=style&index=0&id=050cfd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050cfd70",
  null
  
)

export default component.exports